"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const hoaUsersListWithPagination = (0, graphql_tag_1.default)`
  query users_hoaUsersList(
    $isMention: Boolean
    $roles: [UserRolesGraphQLEnumFilter]
    $isRegistered: UserRegisteredStatusGraphQLEnumFilter
    $before: Int
    $after: Int
    $first: Int
    $last: Int
    $search: String
    $accessLevels: [UserAccessLevelsGraphQLEnumFilter]
  ) {
    users {
      hoaUsersList(
        roles: $roles
        isRegistered: $isRegistered
        accessLevels: $accessLevels
        before: $before
        after: $after
        first: $first
        last: $last
        search: $search
        isMention: $isMention
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
        edges {
          cursor
          node {
            id
            hasPrivateProfile
            nickname
            avatarUrl
            avatarColor
            avatarBorderColor
            avatarText
            avatarDisplayName
            showMyAvatar
            firstName
            lastName
            middleName
            juristicPersonInn
            juristicPersonLegalForm
            juristicPersonName
            juristicPersonOgrn
            personType
            account {
              id
              email {
                id
                type
                value
                isVerified
                verificationSendTime
              }
              phone {
                id
                type
                value
                isVerified
                verificationSendTime
              }
            }
            fullName
            role
            accessLevel
            isRegistered
            membership
            ownershipAddress
          }
        }
      }
    }
  }
`;
exports.default = hoaUsersListWithPagination;